import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';
import { OpcionModel } from '../Global/Opcion.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';

import { MatSnackBar } from '@angular/material';
import { DataTableBodyCellComponent } from '@swimlane/ngx-datatable';
import { IfObservable } from 'rxjs/observable/IfObservable';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';



@Component({
    selector: 'DisminucionBaseRendimientos',
	templateUrl: './DisminucionBaseRendimientos.component.html',
	styleUrls: ['../../../../styles.css']
})

/**
* @author Michael
* @since  22/04/2019
**/
export class DisminucionBaseRendimientos {

	public form: FormGroup;
	public formErrors: any;

    public nombreBeneficiario: string;
    public ID_UNIQUE: string;
    public observacion: string;
    public valorIndenmizacion: string;
    public valorRendimientos: string;
    public valorIndenmizacionDisminuir: number;
    public valorRendimientosDisminuir: number;
    public fecha:Date;

    public ocultar: boolean = false;
	public mensaje: string = "";
    
	public guardando: boolean = true;

	myControl = new FormControl();
	filteredOptions: Observable<OpcionModel[]>;
	

	public btnConsultar: boolean;


	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog) {

            this.formErrors = {
                ID_UNIQUE: {},
                nombreBeneficiario:{},
                observacion:{},
                valorIndenmizacion:{},
                valorRendimientos:{},
                valorIndenmizacionDisminuir:{},
                valorRendimientosDisminuir:{},
                fecha: {},
            };

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
        this.snackBar.dismiss();
    }


    ngOnInit() {
        this.inicializarFormulario();
    }

	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

    openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}


    inicializarFormulario() {
        
		this.form = this.formBuilder.group({
            ID_UNIQUE: ['', Validators.required],
            nombreBeneficiario: [''],
            observacion: ['', Validators.required],
            valorIndenmizacion:[''],
            valorRendimientos:[''],
            valorIndenmizacionDisminuir:['', Validators.required],
            valorRendimientosDisminuir:['', Validators.required],
            fecha: ['', Validators.required],
		});

		
    }

    
    disminuirValores(){
    
        if (this.form.valid == false) {
			if (this.ID_UNIQUE == null  )
			{
				this.openSnackBarEspecial("El campo ID_UNIQUE esta sin diligenciar", "X");
				return;
            }

            if (this.observacion == null  )
			{
				this.openSnackBarEspecial("El campo Observacion esta sin diligenciar", "X");
				return;
            }

            if (this.valorIndenmizacionDisminuir == null  )
			{
				this.openSnackBarEspecial("El campo Valor Indenmización esta sin diligenciar", "X");
				return;
            }

            if (this.valorRendimientosDisminuir == null  )
			{
				this.openSnackBarEspecial("El campo Valor Rendimientos esta sin diligenciar", "X");
				return;
            }

            if (this.fecha == null  )
			{
				this.openSnackBarEspecial("El campo fecha esta sin diligenciar", "X");
				return;
            }
		}
        
        if (this.valorIndenmizacionDisminuir.toString()=='' ){
            this.openSnackBarEspecial("El campo Valor Indenmización esta sin diligenciar ", "X");
            return;
        }


        if (this.valorRendimientosDisminuir.toString()=='' ){
            this.openSnackBarEspecial("El campo Valor Rendimientos esta sin diligenciar", "X");
            return;
        }

        if (this.fecha.toString()==''){
            this.openSnackBarEspecial("El campo fecha esta sin diligenciar", "X");
            return;
        }



        if(this.valorIndenmizacionDisminuir <= 0 || this.valorRendimientosDisminuir <= 0){
            this.openSnackBarEspecial("Los valores a disminuir deben ser mayores a cero", "X");
            return;
        }


        if( this.valorIndenmizacionDisminuir > Number(this.valorIndenmizacion)){
            this.openSnackBarEspecial("El valor de la base a disminuir supera el valor de base que trae el beneficiario ", "X");
            return;
        }

        if( this.valorRendimientosDisminuir > Number(this.valorRendimientos)){
            this.openSnackBarEspecial("El valor del rendimiento a disminuir supera el valor del rendimiento que trae el beneficiario ", "X");
            return;
        }



        this.guardando=false;


        let parametros = {
                           ID_UNIQUE : this.ID_UNIQUE.toString(),
                           VALORINDENMIZACIONDISMINUIR : this.valorIndenmizacionDisminuir.toString(),
                           VALORRENDIMIENTOSDISMINUIR : this.valorRendimientosDisminuir.toString(),
                           observacion: this.observacion,
                           FECHA: new Date(this.fecha).toISOString().substr(0, 10),
                           VUSUARIO: this._serviciosGenerales.seguridad.getInfoSesion().usuario
                        };

        this._serviciosGenerales.get('procedure/PRC_DISMINUIR_VALORES', parametros).subscribe(
            result => {

                if (result.error == true || result.mensaje.toUpperCase().indexOf('OK') == -1) {
                    this.openSnackBarEspecial(result.mensaje, "X");
                    this.guardando = true;
                    return;
                } else {
                    this.form.reset();
                    this.form.clearAsyncValidators();
                    this.form.clearValidators();
                    this.inicializarFormulario();
                    this.nombreBeneficiario='';
                    this.valorIndenmizacion='';
                    this.valorRendimientos='';
                    this.valorIndenmizacionDisminuir=0;
                    this.valorRendimientosDisminuir=0;
                    this.openSnackBar(result.mensaje.replace('OK',''), "X");
                }
                this.guardando = true;
            }, error => {
                var errorMensaje = <any>error;
                console.log('Error al enviar la peticion ', errorMensaje);
                this.openSnackBarEspecial("No se logró obtener la respuesta del servidor, por favor verificar si se efectuó este proceso.", "X");
                this.guardando = true;
            })
    }



    traerInformacionBeneficiario(id){
    

        this._serviciosGenerales.get('informacionBeneficiario', {id_iunique: this.ID_UNIQUE}).subscribe(
            result => {
                
                
                    for (let x of result) {
                        this.nombreBeneficiario = x.nombre;
                        this.valorIndenmizacion = x.valor;
                        this.valorRendimientos = x.rendimientos;
                    }
                
            },
            error => {
                var errorMensaje = <any>error;
                console.log('Error al enviar la peticion ', errorMensaje);

            });

    }


    bloquearBoton(){
		var count = 1;
		this.disminuirValores();
	}
    
}





// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/DisminucionBaseRendimientos/DisminucionBaseRendimientos.component.ts